import { DEFAULT_DELIVERY_PERIOD_ID } from '../../models/config-strip-state.models';

export const getNowDateContainer = () => DEFAULT_DELIVERY_PERIOD_ID;
